// Shared status color palette — single source of truth for success/error
// styling used by both <Alert> and the toast system.

export type StatusVariant = 'success' | 'error' | 'info';

export const STATUS_COLORS: Record<StatusVariant, { bg: string; fg: string }> = {
  success: { bg: 'rgb(237, 247, 237)', fg: 'rgb(30, 70, 32)' },
  error: { bg: 'rgb(253, 237, 237)', fg: 'rgb(95, 33, 32)' },
  info: { bg: 'rgb(229, 246, 253)', fg: 'rgb(1, 67, 97)' },
};
